// utils/apiBase.js
export function apiBase() {
  if(process.env.NODE_ENV == 'production') {
    return '';
  }
  // Vue CLI: process.env.VUE_APP_API_BASE
  const base = process?.env?.VUE_APP_API_BASE;

  // fallback to same-origin if not set
  return base || '';
}
